const LOCAL_AUTH0_LOGIN_AUDIT_KEY = 'graphium.localAuth0LoginAuditPending';

function isLocalEnvironment() {
    return import.meta.env.VITE_APP_ENV === 'local';
}

export function markLocalAuth0LoginAuditPending() {
    if (!isLocalEnvironment()) {
        return;
    }

    try {
        sessionStorage.setItem(LOCAL_AUTH0_LOGIN_AUDIT_KEY, 'true');
    } catch (e) {
        // Session storage is best-effort and only used for local audit testing.
    }
}

export function consumeLocalAuth0LoginAuditPending() {
    if (!isLocalEnvironment()) {
        return false;
    }

    try {
        const isPending = sessionStorage.getItem(LOCAL_AUTH0_LOGIN_AUDIT_KEY) === 'true';
        sessionStorage.removeItem(LOCAL_AUTH0_LOGIN_AUDIT_KEY);
        return isPending;
    } catch (e) {
        return false;
    }
}
